module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "login-form-container__element--left -padding-bottom"
  }, [_c('div', {
    staticClass: "log-reg-form--login validation-fields-container",
    attrs: {
      "novalidate": "",
      "spellcheck": "false"
    }
  }, [_c('h2', {
    staticClass: "log-reg-form__heading"
  }, [_vm._v(_vm._s(_vm.$t('DO_YOU_HAVE_ACCOUNT_LOGIN')))]), _vm._v(" "), _c('ul', {
    staticClass: "log-reg-form__column"
  }, [_c('li', {
    staticClass: "log-reg-form__list"
  }, [_c('div', {
    staticClass: "validation-texts-container",
    attrs: {
      "id": "loginValidationContainer"
    }
  }, [_c('p', {
    staticClass: "validation-texts-container__text validation-texts-container__text--required-fields"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('FILL_CORRECTLY_ALL_FIELDS')) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "validation-texts-container__text validation-texts-container__text--wrong-login-data"
  }, [_vm._v("\n                            " + _vm._s(_vm.loginFailedMessage) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "validation-texts-container__text validation-texts-container__text--not-activated"
  }, [_vm._v("\n                            " + _vm._s(_vm.loginFailedMessage) + "\n                        ")])])]), _vm._v(" "), _c('li', {
    staticClass: "log-reg-form__list"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "validate-email log-reg-form__input text-input -grey-input",
    attrs: {
      "placeholder": _vm.$t('EMAIL_ADDRESS'),
      "name": "username",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": _vm.inputKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "log-reg-form__list"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "log-reg-form__input text-input -grey-input",
    attrs: {
      "placeholder": _vm.$t('PASSWORD'),
      "name": "password",
      "type": "password",
      "required": "",
      "id": "passwordInput"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }, _vm.inputKeyUp],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "glyphicon glyphicon-eye-open",
    staticStyle: {
      "margin-left": "-40px",
      "cursor": "pointer",
      "display": "initial"
    },
    on: {
      "click": _vm.showPassword
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "log-reg-form__list--remind"
  }, [_c('router-link', {
    staticClass: "log-reg-form__remind-password",
    attrs: {
      "to": "/przypomnij-haslo",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('RESET_PASSWORD')) + "\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "log-reg-form__list--remind"
  }, [_c('router-link', {
    staticClass: "log-reg-form__remind-password",
    attrs: {
      "to": "/wyslij-kod-aktywacyjny",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('SEND_ACTIVATION_LINK_AGAIN')) + "\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "log-reg-form__list"
  }, [_c('button', {
    staticClass: "buttons-container__button -button-red",
    attrs: {
      "id": "loginBtn"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('LOGIN')) + "\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86cfdf06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/auth/login.vue
// module id = 1226
// module chunks = 0